import { useEffect, useState } from 'react';
import { useDebounce } from 'react-use';
import Input from '@components/Input';

interface TextInputProps {
  values: string[];
  onUpdate: (values: string[]) => void;
  placeholder?: string;
}

export function TextInput({ values, onUpdate, placeholder = 'Set a value' }: TextInputProps) {
  const [local, setLocal] = useState(values[0] ?? '');

  useEffect(() => {
    setLocal(values[0] ?? '');
  }, [values]);

  useDebounce(() => onUpdate(local ? [local] : []), 300, [local]);

  return (
    <Input className="bg-white" placeholder={placeholder} value={local} onChange={(e) => setLocal(e.target.value)} />
  );
}
